'use strict';

var _ = require('lodash');
function FareBasisGroupsGridDataService($q, restangular) {
  var dataService = restangular.one('external').all('farebasisgroup');
  function save(data) {
    data = cleanUpData(data);
    return $q.all(_.map(data, function (d) {
      return d.isNewlyAdded ? dataService.customPOST(d) : dataService.customPUT(d);
    }));
  }
  function remove(data) {
    data = cleanUpData(data);
    return $q.all(_.map(data, function (d) {
      return dataService.customOperation('remove', '', {}, {
        'Content-Type': 'application/json'
      }, d);
    }));
  }
  function yesNoToBoolean(value) {
    return (value || '').toLowerCase() === 'yes';
  }
  function cleanUpData(data) {
    return _.map(data, function (d) {
      var item = {
        comments: d.comments,
        fareBasisCodeMapping: (d.fareBasisCodeMapping || '').toUpperCase(),
        fareBasisGroup: d.fareBasisGroup,
        priority: d.priority,
        operatingCarrier: d.operatingCarrier,
        useForAveraging: _.isUndefined(d.useForAveraging) ? true : yesNoToBoolean(d.useForAveraging),
        isNewlyAdded: d.isNewlyAdded
      };
      if (d.marketOrigin) {
        item.marketOrigin = d.marketOrigin;
      }
      if (d.marketDestination) {
        item.marketDestination = d.marketDestination;
      }
      if (d.journeyType) {
        item.journeyType = d.journeyType;
      }
      return item;
    });
  }
  return {
    remove: remove,
    save: save
  };
}
FareBasisGroupsGridDataService.$inject = ['$q', 'Restangular'];
module.exports = FareBasisGroupsGridDataService;